import $ from 'jquery';

$('body').on('click', '.js-toggle-class', function(e) {
    e.preventDefault();

    let $this = $(this);
    let toggleClassName = $this.data('class');

    $this.toggleClass(toggleClassName);

});